import state from './tag.state'
import mutations from './tag.mutations'
import actions from './tag.actions'

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
